import { APP_CONSTANTS } from 'app/constants/app-constants';
import AppSettings from 'app/container/AppSettings';
import BillManagement from 'app/container/BillManagement';
import CreateBill from 'app/container/BillManagement/CreateBill';
import CollectionPanel from 'app/container/CollectionPanel';
import CustomerManagement from 'app/container/CustomerManagement';
import CustomerDetail from 'app/container/CustomerManagement/CustomerDetail';
import EventManagement from 'app/container/EventManagement';
import CreateEvent from 'app/container/EventManagement/CreateEvent';
import FeedbackManagement from 'app/container/FeedbackManagement';
import GameManagement from 'app/container/GameManagement';
import CreateGame from 'app/container/GameManagement/CreateGame';
import GameLeaderboard from 'app/container/GameManagement/Leaderboard';
import CreateFeedback from 'app/container/FeedbackManagement/CreateFeedback';
import GamificationCampaigns from 'app/container/GamificationCampaigns';
import CreateCampaign from 'app/container/GamificationCampaigns/CreateCampaign';
import GamificationCampaignDetail from 'app/container/GamificationCampaigns/CampaignDetail';
import MobileOtpLogin from 'app/container/Login/MobileOtpLogin';
import OtpVerification from 'app/container/Login/OtpVerification';
import MallBanner from 'app/container/MallBanner';
import CreateMallBanner from 'app/container/MallBanner/CreateMallBanner';
import BannerAnalytics from 'app/container/MallBanner/BannerAnalytics';
import MallManagement from 'app/container/MallManagement';
import CreateMall from 'app/container/MallManagement/CreateMall';
import MallSupportService from 'app/container/MallSupportService';
import CreateMallSupportService from 'app/container/MallSupportService/CreateMallSupportService';
import NotificationManagement from 'app/container/NotificationManagement';
import CreateNotification from 'app/container/NotificationManagement/CreateNotification';
import OfferDeal from 'app/container/OfferDeal';
import CreateOffer from 'app/container/OfferDeal/CreateOffer';
import PageNotFound from 'app/container/PageNotFound';
import ReportsManagement from 'app/container/ReportsManagement';
import StoreMangement from 'app/container/StoreMangement';
import CreateMenu from 'app/container/StoreMangement/CreateMenu';
import CreateStore from 'app/container/StoreMangement/CreateStore';
import TierManagement from 'app/container/TierManagement';
import CreateDefaultTier from 'app/container/TierManagement/CreateDefaultTier';
import CreateFestiveTier from 'app/container/TierManagement/CreateFestiveTier';
import UserManagement from 'app/container/UserManagement';
import CreatePermission from 'app/container/UserManagement/CreatePermission';
import CreateUser from 'app/container/UserManagement/CreateUser';
import UserProfilePage from 'app/container/UserProfilePage';
import VoucherManagemnet from 'app/container/VoucherManagement';
import CreateVoucher from 'app/container/VoucherManagement/CreateVoucher';
import CreatePackage from 'app/container/VoucherManagement/CreatePackage';
import CancelVoucher from 'app/container/CancelVoucher';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import RoleBasedRoute from './RoleBasedRoute';

const CmsRoutes = () => {
  const token = localStorage.getItem('accessToken');
  const newauth = token && typeof token === 'string';
  return (
    <Router>
      <Routes>
        <Route
          path='/'
          element={newauth ? <UserProfilePage /> : <MobileOtpLogin />}
        />

        <Route path='/otpscreen' element={<OtpVerification />} />
        <Route path='*' element={<PageNotFound />} />
        <Route path={APP_CONSTANTS.Profile} element={<UserProfilePage />} />

        <Route element={<RoleBasedRoute requiredRole={['su']} />}>
          <Route path={APP_CONSTANTS.CREATE_MALL} element={<CreateMall />} />
          <Route path={APP_CONSTANTS.EDIT_MALL} element={<CreateMall />} />
          <Route path={APP_CONSTANTS.MALL_BANNER} element={<MallBanner />} />
          <Route
            path={APP_CONSTANTS.CREATE_MALL_BANNER}
            element={<CreateMallBanner />}
          />
          <Route
            path={APP_CONSTANTS.EDIT_MALL_BANNER}
            element={<CreateMallBanner />}
          />
          <Route
            path={APP_CONSTANTS.BANNER_ANALYTICS}
            element={<BannerAnalytics />}
          />
        </Route>

        <Route element={<RoleBasedRoute requiredRole={['admin', 'su']} />}>
          <Route path={APP_CONSTANTS.USERS} element={<UserManagement />} />
          <Route path={APP_CONSTANTS.CREATE_USER} element={<CreateUser />} />
          <Route path={APP_CONSTANTS.EDIT_USER} element={<CreateUser />} />
          <Route
            path={APP_CONSTANTS.CREATE_PERMISSION_USER}
            element={<CreatePermission />}
          />
          <Route
            path={APP_CONSTANTS.CUSTOMER_MANAGEMENT}
            element={<CustomerManagement />}
          />
          <Route
            path={APP_CONSTANTS.DETAILS_CUSTOMER_MANAGEMENT}
            element={<CustomerDetail />}
          />
          <Route
            path={APP_CONSTANTS.COLLECTION_PANEL}
            element={<CollectionPanel />}
          />
          <Route
            path={APP_CONSTANTS.FEEDBACK_MANAGEMENT}
            element={<FeedbackManagement />}
          />
          <Route
            path={APP_CONSTANTS.CREATE_FEEDBACK}
            element={<CreateFeedback />}
          />
          <Route
            path={APP_CONSTANTS.EDIT_FEEDBACK}
            element={<CreateFeedback />}
          />
          <Route path={APP_CONSTANTS.STORE} element={<StoreMangement />} />
          <Route path={APP_CONSTANTS.CREATE_STORE} element={<CreateStore />} />
          <Route path={APP_CONSTANTS.EDIT_STORE} element={<CreateStore />} />
          <Route path={APP_CONSTANTS.MENU} element={<CreateMenu />} />
          <Route path={APP_CONSTANTS.MALL} element={<MallManagement />} />

          <Route
            path={APP_CONSTANTS.SUPPORT_SERVICE}
            element={<MallSupportService />}
          />
          <Route
            path={APP_CONSTANTS.CREATE_SUPPORT_SERVICE}
            element={<CreateMallSupportService />}
          />
          <Route
            path={APP_CONSTANTS.EDIT_SUPPORT_SERVICE}
            element={<CreateMallSupportService />}
          />
          <Route path={APP_CONSTANTS.OFFER_DEALS} element={<OfferDeal />} />
          <Route
            path={APP_CONSTANTS.CREATE_OFFER_DEALS}
            element={<CreateOffer />}
          />
          <Route
            path={APP_CONSTANTS.EDIT_OFFER_DEALS}
            element={<CreateOffer />}
          />
          <Route path={APP_CONSTANTS.EVENT} element={<EventManagement />} />
          <Route path={APP_CONSTANTS.CREATE_EVENT} element={<CreateEvent />} />
          <Route path={APP_CONSTANTS.EDIT_EVENT} element={<CreateEvent />} />
          <Route
            path={APP_CONSTANTS.GAME_MANAGEMENT}
            element={<GameManagement />}
          />
          <Route path={APP_CONSTANTS.CREATE_GAME} element={<CreateGame />} />
          <Route path={APP_CONSTANTS.EDIT_GAME} element={<CreateGame />} />
          <Route
            path={APP_CONSTANTS.GAME_LEADERBOARD}
            element={<GameLeaderboard />}
          />
          <Route path={APP_CONSTANTS.TIER} element={<TierManagement />} />
          <Route
            path={APP_CONSTANTS.EDIT_FESTIVE_TIER}
            element={<CreateFestiveTier />}
          />
          <Route
            path={APP_CONSTANTS.CREATE_FESTIVE_TIER}
            element={<CreateFestiveTier />}
          />
          <Route
            path={APP_CONSTANTS.CREATE_DEFAULT_TIER}
            element={<CreateDefaultTier />}
          />
          <Route
            path={APP_CONSTANTS.EDIT_DEFAULT_TIER}
            element={<CreateDefaultTier />}
          />
          <Route path={APP_CONSTANTS.VOUCHER} element={<VoucherManagemnet />} />
          <Route
            path={APP_CONSTANTS.CANCEL_VOUCHER}
            element={<CancelVoucher />}
          />
          <Route
            path={APP_CONSTANTS.CREATE_VOUCHER}
            element={<CreateVoucher />}
          />
          <Route
            path={APP_CONSTANTS.EDIT_VOUCHER}
            element={<CreateVoucher />}
          />
          <Route
            path={APP_CONSTANTS.CREATE_PACKAGE}
            element={<CreatePackage />}
          />
          <Route
            path={APP_CONSTANTS.EDIT_PACKAGE}
            element={<CreatePackage />}
          />
          <Route
            path={APP_CONSTANTS.BILL_VALIDATION}
            element={<BillManagement />}
          />
          <Route
            path={APP_CONSTANTS.CREATE_BILL_VALIDATION}
            element={<CreateBill />}
          />
          <Route
            path={APP_CONSTANTS.NOTIFICATION}
            element={<NotificationManagement />}
          />
          <Route
            path={APP_CONSTANTS.CREATE_NOTIFICATION}
            element={<CreateNotification />}
          />
          <Route
            path={APP_CONSTANTS.EDIT_NOTIFICATION}
            element={<CreateNotification />}
          />
          <Route path={APP_CONSTANTS.REPORTS} element={<ReportsManagement />} />
          <Route
            path={APP_CONSTANTS.GAMIFICATION_CAMPAIGNS}
            element={<GamificationCampaigns />}
          />
          <Route
            path={APP_CONSTANTS.GAMIFICATION_CREATE_CAMPAIGN}
            element={<CreateCampaign />}
          />
          <Route
            path={APP_CONSTANTS.GAMIFICATION_CAMPAIGN_DETAIL}
            element={<GamificationCampaignDetail />}
          />
          <Route
            path={APP_CONSTANTS.APP_SETTINGS}
            element={<AppSettings />}
          />
        </Route>
      </Routes>
    </Router>
  );
};

export default CmsRoutes;
